var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],attrs:{"no-gutters":"","align":"start","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('div',{staticClass:"d-flex justify-end pa-1"},[_vm._v("\n      Total Saldo Pendiente:  \n      "),_c('span',{class:[
          'font-weight-bold body-2',
          {
            'error--text': _vm.sumaPendiente < 0,
          } ]},[_vm._v("\n        "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n        "+_vm._s(_vm._f("numeral")(_vm.sumaPendiente,"0,0.00"))+"\n      ")])]),_c('v-data-table',{staticClass:"elevation-1",class:{ mobile: _vm.isMobile },attrs:{"loading":_vm.datosNew.length === 0 ? '#002f6c' : null,"headers":_vm.headersCliente,"items":_vm.datosNew,"hide-default-header":_vm.isMobile,"height":"600px","fixed-header":"","search":_vm.search,"custom-filter":_vm.filteRif,"hide-default-footer":"","disable-pagination":"","single-select":"","sort-by":"position","sort-desc":"","item-key":"NumeroDoc","group-by":_vm.chkGrpClie_Rif ? 'Empresa' : 'NombreRif',"show-group-by":"","dense":"","mobile-breakpoint":0,"id":"tbl_datos"},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{attrs:{"flat":""}},[_c('PdfCliente',{attrs:{"page":"clientedoc.php","xdata":_vm.infoTt("ttDetDocPed"),"xclisaldo":_vm.infoTt("ttSaldos"),"xcli":_vm.infoTt("ttCliente"),"namefile":"EstadoCuentaPendiente(" + _vm.nbFile + ")","titulo":"DETALLE ESTADO DE CUENTA PENDIENTE"}}),(_vm.dataUser.TipoUsuario == 'U')?_c('ExportDocsPendientes',{attrs:{"rows":_vm.datosNew,"orderkey":_vm.chkGrpClie_Rif,"tipodoc":_vm.DetalleCliente.dsDocument &&
              _vm.DetalleCliente.dsDocument.ttTotalTipoDoc,"cliente":_vm.DetalleCliente.dsDocument &&
              _vm.DetalleCliente.dsDocument.ttCliente &&
              _vm.DetalleCliente.dsDocument.ttCliente[0]}}):_vm._e(),(_vm.Cliente.data.GrupoCliente!== 0)?_c('v-switch',{staticClass:"mx-5",attrs:{"hide-details":"","color":"accent","inset":"","flat":"","dense":"","label":_vm.chkGrpClie_Rif ? "Grupo Empresa" : 'Grupo Rif'},model:{value:(_vm.chkGrpClie_Rif),callback:function ($$v) {_vm.chkGrpClie_Rif=$$v},expression:"chkGrpClie_Rif"}}):_vm._e(),_c('v-row',[_c('v-spacer'),(_vm.Cliente.data.GrupoCliente!== 0)?_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-select',{attrs:{"items":_vm.rifList,"item-text":"NombreRif","item-value":"Rif","clearable":"","clear-icon":"mdi-close","dense":"","outlined":"","chips":"","menu-props":{
                  top: false,
                  offsetY: true,
                  maxHeight: '200',
                  maxWidth: '380',
                  closeOnContentClick: true,
                },"label":"Por RIF "},on:{"click:clear":_vm.toggle},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
                var item = ref.item;
return [_c('v-chip',{attrs:{"color":"accent mt-1 ml-n1 font-weight-bold","label":""}},[_vm._v("\n                    "+_vm._s(item.NombreRif)+"\n                  ")])]}}],null,false,243960657),model:{value:(_vm.selectRif),callback:function ($$v) {_vm.selectRif=$$v},expression:"selectRif"}})],1):_vm._e(),_c('v-col',{attrs:{"cols":"12","md":"4"}},[_c('v-text-field',{attrs:{"dense":"","outlined":"","color":"primary","single-line":"","append-icon":"mdi-magnify","label":"Buscar por Num Doc o Monto/Saldo","hide-details":"","type":"text","background-color":"#EEEEEE"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1)]},proxy:true},{key:"group.header",fn:function(ref){
                var items = ref.items;
                var group = ref.group;
                var headers = ref.headers;
                var toggle = ref.toggle;
                var isOpen = ref.isOpen;
return [_c('td',{attrs:{"colspan":headers.length}},[_c('v-btn',{ref:group,attrs:{"x-small":"","icon":""},on:{"click":toggle}},[(isOpen)?_c('v-icon',[_vm._v("mdi-minus")]):_c('v-icon',[_vm._v("mdi-plus")])],1),_c('span',{staticClass:"mx-6 font-weight-bold",staticStyle:{"color":"#002f6c"}},[_vm._v("\n            "+_vm._s(_vm.chkGrpClie_Rif
                ? items
                    .filter(function (x) { return x.Empresa === group; })
                    .map(function (x) { return x.NombreCli; })[0]
                : items
                    .filter(function (x) { return x.NombreRif === group; })
                    .map(function (x) { return x.NombreRif; })[0])+"\n          ")])],1)]}},(!_vm.isMobile)?{key:"group.summary",fn:function(ref){
                    var items = ref.items;
                    var group = ref.group;
return [_c('td',{attrs:{"colspan":"7"}}),_c('td',{class:[
            'text-right font-weight-bold body-2',
            {
              'error--text':
                _vm.montoGroupSumary({
                  isEmpreRif: _vm.chkGrpClie_Rif,
                  items: items,
                  keyMap: "MontoOriginal",
                  group: group,
                  tipoMoneda: _vm.tipoMoneda,
                }) < 0,
            } ],staticStyle:{"width":"150px"}},[_c('span',[_vm._v(_vm._s(_vm.simboloMoneda[_vm.tipoMoneda]))]),_vm._v("\n          "+_vm._s(_vm._f("numeral")(_vm.montoGroupSumary({
              isEmpreRif: _vm.chkGrpClie_Rif,
              items: items,
              keyMap: "MontoOriginal",
              group: group,
              tipoMoneda: _vm.tipoMoneda,
            }),"0,0.00"))+"\n        ")]),_c('td',{class:[
            'text-right font-weight-bold body-2',
            {
              'error--text':
                _vm.montoGroupSumary({
                  isEmpreRif: _vm.chkGrpClie_Rif,
                  items: items,
                  keyMap: "MontoRetIva",
                  group: group,
                  tipoMoneda: _vm.tipoMoneda,
                }) < 0,
            } ],staticStyle:{"width":"150px"}},[_c('span',[_vm._v(_vm._s(_vm.simboloMoneda[_vm.tipoMoneda]))]),_vm._v("\n          "+_vm._s(_vm._f("numeral")(_vm.montoGroupSumary({
              isEmpreRif: _vm.chkGrpClie_Rif,
              items: items,
              keyMap: "MontoRetIva",
              group: group,
              tipoMoneda: _vm.tipoMoneda,
            }),"0,0.00"))+"\n        ")]),_c('td',{class:[
            'text-right font-weight-bold body-2',
            {
              'error--text':
                _vm.montoGroupSumary({
                  isEmpreRif: _vm.chkGrpClie_Rif,
                  items: items,
                  keyMap: "MontoPagar",
                  group: group,
                  tipoMoneda: _vm.tipoMoneda,
                }) < 0,
            } ],staticStyle:{"width":"150px"}},[_c('span',[_vm._v(_vm._s(_vm.simboloMoneda[_vm.tipoMoneda]))]),_vm._v("\n          "+_vm._s(_vm._f("numeral")(_vm.montoGroupSumary({
              isEmpreRif: _vm.chkGrpClie_Rif,
              items: items,
              keyMap: "MontoPagar",
              group: group,
              tipoMoneda: _vm.tipoMoneda,
            }),"0,0.00"))+"\n        ")]),_c('td',{class:[
            'text-right font-weight-bold body-2',
            {
              'error--text':
                _vm.montoGroupSumary({
                  isEmpreRif: _vm.chkGrpClie_Rif,
                  items: items,
                  keyMap: "SaldoPendiente",
                  group: group,
                  tipoMoneda: _vm.tipoMoneda,
                }) < 0,
            } ],staticStyle:{"width":"150px"}},[_c('span',[_vm._v(_vm._s(_vm.simboloMoneda[_vm.tipoMoneda]))]),_vm._v("\n          "+_vm._s(_vm._f("numeral")(_vm.montoGroupSumary({
              isEmpreRif: _vm.chkGrpClie_Rif,
              items: items,
              keyMap: "SaldoPendiente",
              group: group,
              tipoMoneda: _vm.tipoMoneda,
            }),"0,0.00"))+"\n        ")]),_c('td')]}}:null,{key:"item",fn:function(ref){
            var item = ref.item;
return [(!_vm.isMobile)?_c('tr',{attrs:{"data-category-id":item.Empresa,"data-id":item.NumeroDoc}},[_c('td',{staticClass:"d-print-none"},[_c('linkfact',{attrs:{"itemfac":item.IndFactura,"numerodoc":item.NumeroDoc,"tipodoc":item.TD,"idtab":1,"transi":true}})],1),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.Rif)+"\n          ")]),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.NumeroDoc)+"\n          ")]),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.TipoDoc)+"\n          ")]),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.FechaEmision
                ? _vm.moment(item.FechaEmision).format("DD/MM/YY")
                : "")+"\n          ")]),_c('td',{class:['text-center']},[(item.FechaEntregaCli)?_c('v-edit-dialog',{attrs:{"transition":"scroll-y-transition"},scopedSlots:_vm._u([(_vm.DetalleCliente.dsDocument)?{key:"input",fn:function(){return [_c('v-card',{attrs:{"flat":"","width":"550","elevation":"1"}},[_c('v-toolbar',{staticStyle:{"height":"25px"},attrs:{"dense":"","color":"primary","dark":""}},[_c('v-toolbar-title',{staticClass:"body-1 mb-4"},[_vm._v("\n                      Detalle de Despacho Documento N°\n                      "),_c('strong',[_vm._v(_vm._s(item.NumeroDoc))])]),_c('v-spacer')],1),_c('TrackCliente',{attrs:{"detallecliente":_vm.DetalleCliente,"numdoc":item.NumeroDoc}})],1)]},proxy:true}:null],null,true)},[_c('span',{staticClass:"text-decoration-underline"},[_vm._v("\n                "+_vm._s(item.FechaEntregaCli
                    ? _vm.moment(item.FechaEntregaCli).format("DD/MM/YY")
                    : "")+"\n              ")])]):_vm._e()],1),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.FechaVence
                ? _vm.moment(item.FechaVence).format("DD/MM/YY")
                : "")+"\n          ")]),_c('td',{class:[
              'text-right',
              {
                'error--text': item.MontoOriginal[_vm.tipoMoneda] < 0,
              } ],staticStyle:{"width":"150px"}},[_vm._v("\n            "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n            "+_vm._s(_vm._f("numeral")(item.MontoOriginal[_vm.tipoMoneda],"0,0.00"))+"\n          ")]),_c('td',{class:[
              'text-right' ],staticStyle:{"width":"150px"}},[_vm._v("\n            "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n            "+_vm._s(_vm._f("numeral")(item.MontoRetIva[_vm.tipoMoneda],"0,0.00"))+"\n          ")]),_c('td',{class:[
              'text-right' ],staticStyle:{"width":"150px"}},[_vm._v("\n            "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n            "+_vm._s(_vm._f("numeral")(item.MontoPagar[_vm.tipoMoneda],"0,0.00"))+"\n          ")]),_c('td',{class:[
              'text-right',
              {
                'error--text': item.SaldoPendiente[_vm.tipoMoneda] < 0,
              } ],staticStyle:{"width":"150px"}},[_vm._v("\n            "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n            "+_vm._s(_vm._f("numeral")(item.SaldoPendiente[_vm.tipoMoneda],"0,0.00"))+"\n          ")]),_c('td',{class:['text-center']},[_vm._v("\n            "+_vm._s(item.DiasMora)+"\n          ")])]):_vm._e()]}}],null,true)},[(_vm.datosNew.length !== 0 && _vm.selectRif === 0)?_c('template',{slot:"body.append"},[_c('tr',[_vm._l((7),function(n){return _c('th',{key:n})}),_c('th',{class:[
              'subtitle-1',
              'text-right',
              'font-weight-bold',
              'text-no-wrap',
              {
                'error--text': _vm.montoTotalSumary({
                  keyMap: "MontoOriginal",
                  items: _vm.datosNew,
                  tipoMoneda: _vm.tipoMoneda,
                }).includes('-'),
              } ]},[_vm._v("\n            "+_vm._s(((_vm.simboloMoneda[_vm.tipoMoneda]) + " " + (_vm.montoTotalSumary({
                keyMap: "MontoOriginal",
                items: _vm.datosNew,
                tipoMoneda: _vm.tipoMoneda,
              }))))+"\n          ")]),_c('th',{class:[
              'subtitle-1',
              'text-right',
              'font-weight-bold',
              'text-no-wrap',
              {
                'error--text': _vm.montoTotalSumary({
                  keyMap: "MontoRetIva",
                  items: _vm.datosNew,
                  tipoMoneda: _vm.tipoMoneda,
                }).includes('-'),
              } ]},[_vm._v("\n            "+_vm._s(((_vm.simboloMoneda[_vm.tipoMoneda]) + " " + (_vm.montoTotalSumary({
                keyMap: "MontoRetIva",
                items: _vm.datosNew,
                tipoMoneda: _vm.tipoMoneda,
              }))))+"\n          ")]),_c('th',{class:[
              'subtitle-1',
              'text-right',
              'font-weight-bold',
              'text-no-wrap',
              {
                'error--text': _vm.montoTotalSumary({
                  keyMap: "MontoPagar",
                  items: _vm.datosNew,
                  tipoMoneda: _vm.tipoMoneda,
                }).includes('-'),
              } ]},[_vm._v("\n            "+_vm._s(((_vm.simboloMoneda[_vm.tipoMoneda]) + " " + (_vm.montoTotalSumary({
                keyMap: "MontoPagar",
                items: _vm.datosNew,
                tipoMoneda: _vm.tipoMoneda,
              }))))+"\n          ")]),_c('th',{class:[
              'subtitle-1',
              'text-right',
              'font-weight-bold',
              'text-no-wrap',
              {
                'error--text': _vm.montoTotalSumary({
                  keyMap: "SaldoPendiente",
                  items: _vm.datosNew,
                  tipoMoneda: _vm.tipoMoneda,
                }).includes('-'),
              } ]},[_vm._v("\n            "+_vm._s(((_vm.simboloMoneda[_vm.tipoMoneda]) + " " + (_vm.montoTotalSumary({
                keyMap: "SaldoPendiente",
                items: _vm.datosNew,
                tipoMoneda: _vm.tipoMoneda,
              }))))+"\n          ")]),_c('th')],2)]):_vm._e()],2),_c('div',{staticClass:"d-flex justify-end pa-1"},[_vm._v("\n      Total Saldo Pendiente:  \n      "),_c('span',{class:[
          'font-weight-bold body-2',
          {
            'error--text': _vm.sumaPendiente < 0,
          } ]},[_vm._v("\n        "+_vm._s(_vm.simboloMoneda[_vm.tipoMoneda])+"\n        "+_vm._s(_vm._f("numeral")(_vm.sumaPendiente,"0,0.00"))+"\n      ")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }